import { render, staticRenderFns } from "./AddProperty.vue?vue&type=template&id=650800aa"
import script from "./AddProperty.vue?vue&type=script&lang=js"
export * from "./AddProperty.vue?vue&type=script&lang=js"
import style0 from "./AddProperty.vue?vue&type=style&index=0&id=650800aa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports